export default __webpack_public_path__ + "static/media/carte.27fd18ce.png";